import * as React from 'react';
import { useLazyQuery } from 'react-apollo';
import Cookies from 'js-cookie';
import { AdvertisingScrambledIdDocument as GET_SCRAMBLED_ID } from './advertisingScrambledId.gql-types';
export const useScrambledId = () => {
    const [fetchScrambledId] = useLazyQuery(GET_SCRAMBLED_ID, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            var _a, _b;
            if ((_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.advertisingScrambledId) {
                Cookies.set('s_id', (_b = data === null || data === void 0 ? void 0 : data.viewer) === null || _b === void 0 ? void 0 : _b.advertisingScrambledId, {
                    expires: 30,
                });
            }
        },
    });
    React.useEffect(() => {
        var _a;
        if (!Cookies.get('s_id') &&
            ((_a = Cookies.get('userConsent')) === null || _a === void 0 ? void 0 : _a.includes('"marketing":true'))) {
            fetchScrambledId();
        }
    }, []);
};
//# sourceMappingURL=scrambled-id.js.map